import React from 'react'
import { getDay, format } from 'date-fns'
import PreferMobile from './PreferMobile'
import HowItWorks from './HowItWorks'
import RestaurantShowcase from './RestaurantShowcase'

const daysOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]

export const UnderSixDays = ({
  activationDate,
  isAuthenticated,
  onChangeDay,
  loadingDeliveringRestaurants,
  restaurantLogos,
  showJoin
}) => {
  const SERVING_LOCATION_ON = getDay(activationDate)
  return (
    <div className="row center-xs">
      <div className="col-xs-12">
        <h2 className="coming-soon-title">
          Starting{' '}
          <button
            onClick={() =>
              onChangeDay(format(activationDate, 'YYYYMMDD'), isAuthenticated)
            }
            className="link coming-soon-day-button"
            style={{ fontSize: '31px', fontWeight: '700' }}
          >
            {daysOfWeek[SERVING_LOCATION_ON]}
          </button>
          , {format(activationDate, 'MMMM Do')}!
        </h2>
        {!isAuthenticated && (
          <div style={{ paddingTop: '12px' }}>
            <button
              onClick={() => {
                showJoin()
              }}
              className="primary"
            >
              Create Account
            </button>
          </div>
        )}
        {isAuthenticated ? <PreferMobile /> : null}
        <hr className="coming-soon-hr" />
        <HowItWorks />
        <hr className="coming-soon-hr" />
        {loadingDeliveringRestaurants ? (
          <i className="spinner spinner-lg primary" />
        ) : (
          <RestaurantShowcase restaurantLogos={restaurantLogos} />
        )}
      </div>
    </div>
  )
}

export default UnderSixDays
